import ox from '@/ox'
import $ from '@/jquery'
import { settings as coreSettings } from '@/io.ox/core/settings'
import { settings as mailSettings } from '@/io.ox/mail/settings'
import { getCurrent } from '@/io.ox/core/theming/main'

export function getVariables (context = {}) {
  return {
    context_id: ox.context_id,
    hostname: location.hostname,
    id: context.id || '',
    // missing
    imap_login: '',
    language: ox.language,
    mail: mailSettings.get('defaultaddress', ''),
    missing: context.missing || '',
    session: ox.session,
    type: context.type || '',
    user: ox.user,
    user_id: ox.user_id,
    // missing
    user_login: '',
    // default data for plan is for testing/demo purposes
    plan: $.param(context.plan || { id: 'pro', price: 4, offer: 3.6, period: 1, discount: 10, color: getCurrent()?.accentColor })
  }
}

export function renderUrl (url = '', context = {}) {
  const hash = getVariables(context)
  return String(url).replace(/\$(\w+)/g, function (all, key) {
    key = String(key).toLowerCase()
    if (key === 'plan') return hash[key]
    return key in hash ? encodeURIComponent(hash[key]) : '$' + key
  })
}

export function deriveCheckoutUrl (context = {}) {
  const urls = coreSettings.get('upsell/checkout/urls', {})
  const { id, missing, type } = context
  const lang = getCurrentLanguage()
  const url = urls[`${type}.${id}.${lang}`] ||
    urls[`${type}.${id}`] ||
    urls[`missing.${missing}.${lang}`] ||
    urls[`missing.${missing}`] ||
    urls[`default.${lang}`] ||
    urls.default ||
    `${ox.root}/pe/upsell/checkout/checkout.html?$plan`
  return renderUrl(url, context)
}

export function getCurrentLanguage () {
  return String(ox.language).substring(0, 2).toLowerCase()
}
